import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { AuthShell } from '../components/auth/AuthShell'
import {
  AuthFormCard,
  AuthField,
  AuthSubmitButton,
  AuthFooterLink,
} from '../components/auth/AuthFormCard'

function ForgotPasswordPage() {
  const { forgotPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)
    setError('')

    try {
      await forgotPassword(email)
      setSubmitted(true)
    } catch (err) {
      setError(err.message || 'Failed to send password reset email')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell>
      <AuthFormCard
        title="Reset password"
        subtitle="Enter your email and we'll send a reset link if the account exists."
        onSubmit={handleSubmit}
        errorMessage={error}
        successMessage={
          submitted ? 'If an account exists, a password reset email has been sent.' : ''
        }
        footer={<AuthFooterLink to="/login">Back to login</AuthFooterLink>}
      >
        <AuthField
          id="email"
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          placeholder="you@company.com"
          required
          autoFocus
          autoComplete="email"
          disabled={loading || submitted}
        />

        <AuthSubmitButton
          loading={loading}
          submitted={submitted}
          loadingLabel="Sending..."
        >
          Send reset email
        </AuthSubmitButton>
      </AuthFormCard>
    </AuthShell>
  )
}

export default ForgotPasswordPage
